import { useEffect } from "react"
import { useParams } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const useDeleteAccountSeedTicket = (ticketTypeIdx, numberRef) => {
    const { idx } = useParams()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    const request = () => {
        fetchRequest("DELETE", `/admin/account/${idx}/seed-ticket`, {
            "seed_ticket_type_idx": ticketTypeIdx,
            "number": numberRef?.current?.value
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                window.location.reload()
                break
            case 400:
                if (fetchResult?.data?.error_code === "account_idx") setAlert("사용자 idx를 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "seed_ticket_idx") setAlert("시드권 idx를 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "number") setAlert("회수 개수를 확인해 주세요.")
                else if (fetchResult?.data?.error_code === 1) setAlert("보유량보다 더 많이 회수할 수 없습니다.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("사용자 데이터가 존재하지 않습니다.")
                else if (fetchResult?.data?.error_code === 2) setAlert("시드권 데이터가 존재하지 않습니다.")
        }
    }, [fetchResult])

    return [request]
}

export default useDeleteAccountSeedTicket